import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../utils";

export const calendarMaintenance = createAsyncThunk('calendarMaintenance', async ({ department_id, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `calendar_maintenance`,
            params: {
                'department_id': department_id
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const calendarMaintenanceSlice = createSlice({
    name: 'calendarMaintenance',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(calendarMaintenance.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = [];
            }

        });
        builder.addCase(calendarMaintenance.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default calendarMaintenanceSlice.reducer; 